var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":`${_vm.url}&brand=0`,"allowfullscreen":"","sandbox":"allow-same-origin allow-scripts allow-popups allow-forms","allow":"vr"}})
}
var staticRenderFns = []

export { render, staticRenderFns }